import { render } from "./NotificatiMessage.vue?vue&type=template&id=076f44c2&scoped=true"
import script from "./NotificatiMessage.vue?vue&type=script&lang=js"
export * from "./NotificatiMessage.vue?vue&type=script&lang=js"

import "./NotificatiMessage.vue?vue&type=style&index=0&id=076f44c2&scoped=true&lang=css"

import exportComponent from "/home/heather/Documents/Work/Soldel/pwa2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076f44c2"]])

export default __exports__